module.exports = __webpack_public_path__ + "fonts/Inter.c52e6d9e.woff2";